import * as React from 'react'
import Autocomplete from 'common/components/Autocomplete'
import useAssets from 'common/components/hooks/useAssetsForDropdowns'
import InputErrorMessage from 'common/components/InputErrorMessage'
import styled from 'styled-components/macro'
import {Icon} from 'semantic-ui-react'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
`
const StyledIcon = styled(Icon)`
  position: absolute;
  right: 7px;
  bottom: 15px;
  font-size: 12px !important;
  cursor: pointer;
`

const StyledIconNoClick = styled(StyledIcon)`
  pointer-events: none;
`

const StyledAutocomplete = styled(Autocomplete)`
  &&& div > .autocomplete-icon {
    color: red;
  }
`

type AssetOption = {id: number; name: string; idDevice_Type: number | undefined}

type AssetsDropdownType = {
  selectAsset: (
    id?: number | null,
    Asset_Label?: string | null,
    idDevice_Type?: number | null,
  ) => void
  selectedID: number | null
  excludeIDs?: number[]
  errors?: {idAsset?: {message: string}; message?: string}
  disabled?: boolean
  label?: string
  required?: boolean
  defaultOpen?: boolean
  clearable?: boolean
  className?: string
  useDriverList?: boolean
}

const AssetsDropdown = ({
  selectAsset,
  selectedID,
  excludeIDs,
  errors,
  disabled = false,
  label,
  required = false,
  defaultOpen = false,
  clearable = false,
  className = '',
  useDriverList = false,
}: AssetsDropdownType) => {
  const {data: assets, status} = useAssets({useDriverList})
  const [assetsList, setAssetsList] = React.useState<AssetOption[]>([])

  React.useEffect(() => {
    const newAssets: AssetOption[] = []
    if (assets && assets.length > 0) {
      assets.forEach(a => {
        if (!excludeIDs || !excludeIDs.includes(a.idAsset)) {
          const newAsset = {
            id: a.idAsset,
            name: a.Asset_Label,
            idDevice_Type: a.idDevice_Type,
          }
          newAssets.push(newAsset)
        }
      })
      setAssetsList(newAssets)
    }
  }, [assets, excludeIDs])

  const assetChanged = (item?: AssetOption | null) => {
    selectAsset(item?.id || null, item?.name, item?.idDevice_Type)
  }

  return (
    <Container className={className} data-cy="assets-dropdown">
      <StyledAutocomplete
        list={assetsList}
        label={label}
        required={required}
        onChange={assetChanged}
        selectedID={selectedID}
        placeholder="Select an asset"
        loading={String(status === 'loading' || !assets)}
        disabled={disabled}
        defaultOpen={defaultOpen}
        showIcon={!selectedID}
      />
      {selectedID && clearable && (
        <>
          <StyledIcon
            data-cy="autocomplete-icon-clear"
            className="close icon"
            onClick={() => assetChanged(null)}
          />
        </>
      )}
      {!clearable && selectedID && (
        <>
          <StyledIconNoClick
            data-cy="autocomplete-icon"
            className="caret down icon"
          />
        </>
      )}
      {errors?.message || errors?.idAsset ? (
        <InputErrorMessage
          message={errors?.message || errors?.idAsset?.message}
        />
      ) : (
        <></>
      )}
    </Container>
  )
}
export default React.memo(AssetsDropdown)
